<h2 mat-dialog-title>Conflicto de disponibilidad</h2>

<mat-dialog-content>
  <div class="conflicts-warning" role="alert">
    <mat-icon aria-hidden="true">warning</mat-icon>
    <div>
      <ul class="conflicts-list">
        @for (message of data.conflict_messages; track message) {
          <li>{{ message }}</li>
        }
      </ul>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" type="button" (click)="proceed()">Continuar</button>
</mat-dialog-actions>
